export const tableBreak = {
  tiny: '(max-width: 360px)',
  small: '(max-width: 616px)',
  medium: '(max-width: 1080px)',
  large: '(max-width: 1460px)',
  huge: '(max-width: 1780px)',
}
